import { apiLogroEditarEstadoAsignacionV3, apiLogroObtenerAsignacionesChild, apiLogroObtenerCategorias, apiLogroObtenerLogros } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, IAsignacionChildLogro, ILogro, ICategoriaLogro } from "../models/Entities";
import { RequestData } from "../utils/RequestData";


export const _LOGRO_ALUMNO_ASIGNACIONES_MAP: Map<number, { childId: number, max: string | null, data: Map<number, IAsignacionChildLogro> }> = new Map();
export function _SvLogroObtenerLogrosAsignacionesChild(childId: number, callback: (result: Array<IAsignacionChildLogro>) => void) {
    const assigns = _LOGRO_ALUMNO_ASIGNACIONES_MAP.get(childId);
    const dtmax = assigns ? assigns.max : null;
    const params = {
        IdChild: childId,
        Modificacion: dtmax || null
    }

    new RequestData<IApiResult<IAsignacionChildLogro[]>>(apiLogroObtenerAsignacionesChild)
        .Params(params)
        .Completion((response, error) => {
            const status = response ? response.Resultado : -111;
            if (error)
                console.log(error.name, error.message);

            const resultData = status == 1 ? response?.Datos || [] : [];

            let mapChildAssig = _LOGRO_ALUMNO_ASIGNACIONES_MAP.get(childId);
            if (!mapChildAssig) mapChildAssig = { childId: childId, max: null, data: new Map() };

            if (resultData.length > 0)
                mapChildAssig.max = response?.Modificacion || null;


            resultData.forEach(item => {
                if (!item.EnUso) {
                    mapChildAssig?.data.delete(item.IdAsignacion);
                    return;
                }

                item.IdChild = childId;
                item.Iniciado = item.Iniciado ? new Date(item.Iniciado) : null;
                item.Avanzado = item.Avanzado ? new Date(item.Avanzado) : null;
                item.Terminado = item.Terminado ? new Date(item.Terminado) : null;

                mapChildAssig?.data.set(item.IdAsignacion, item);
            });

            _LOGRO_ALUMNO_ASIGNACIONES_MAP.set(childId, mapChildAssig);

            if (callback) callback(resultData);

        }).Get();
}

export const _LOGROS_MAP: Map<number, ILogro> = new Map();
let maxUpdatedLogro: string | null;
export function _SvLogroObtenerLogros(callback: (result: Array<ILogro>) => void) {
    const params = {
        Modificacion: maxUpdatedLogro || null,
        IdKinder: _APP_DATA.userData.IdKinder
    }

    new RequestData<IApiResult<ILogro[]>>(apiLogroObtenerLogros)
        .Params(params)
        .Completion((response, error) => {
            const status = response?.Resultado || -111;
            if (error)
                console.log(error.name, error.message);

            const resultData = status == 1 ? response?.Datos || [] : [];

            if (resultData.length > 0)
                maxUpdatedLogro = response?.Modificacion || null;

            resultData.forEach(item => {
                if (item.EnUso) {
                    _LOGROS_MAP.set(item.IdLogro, item);
                } else _LOGROS_MAP.delete(item.IdLogro);
            });

            if (callback) callback(resultData);
        }).Get();
}

export const _LOGRO_CATEGORIAS_MAP: Map<number, ICategoriaLogro> = new Map();
let maxUpdatedCategories: string | null;
export function _SvLogroObtenerCategorias(callback: (result: Array<ICategoriaLogro>) => void) {
    const params = {
        Modificacion: maxUpdatedCategories || null,
        IdKinder: _APP_DATA.userData.IdKinder
    }

    new RequestData<IApiResult<ICategoriaLogro[]>>(apiLogroObtenerCategorias)
        .Params(params)
        .Completion((response, error) => {
            const status = response?.Resultado || -111;
            if (error)
                console.log(error.name, error.message);

            let resultData: Array<ICategoriaLogro> = [];
            if (status == 1) resultData = response?.Datos || [];

            if (resultData.length > 0)
                maxUpdatedCategories = response?.Modificacion || null;

            resultData.forEach(item => {
                if (item.EnUso) {
                    _LOGRO_CATEGORIAS_MAP.set(item.IdCategoria, item);
                } else _LOGRO_CATEGORIAS_MAP.delete(item.IdCategoria);
            });

            if (callback) callback(resultData);
        }).Get();
}

export function _SvLogroEditarEstadoAsignacion(childId: number, logroId: number, newStatus: number, dtEvent: Date, isExtemporal: boolean, callback: (result: number) => void) {
    let params = {
        IdChild: childId,
        IdLogro: logroId,
        Estado: newStatus,
        IdUsuario: _APP_DATA.userData.IdUsuario,
        IdGrupo: _APP_DATA.userData.IdGrupo,
        IdOrganizacion: _APP_DATA.userData.IdOrganizacion,
        ExTemporal: isExtemporal,
        FechaEvento: dtEvent.toISOString()
    }

    new RequestData<IApiResult<number>>(apiLogroEditarEstadoAsignacionV3)
        .Params(params)
        .Completion((response, error) => {
            let status = response?.Resultado || -111;
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(status);
        }).Post();
}

export function _SvLogroClearData() {
    _LOGRO_ALUMNO_ASIGNACIONES_MAP.clear();

    maxUpdatedLogro = null;
    _LOGROS_MAP.clear();

    maxUpdatedCategories = null;
    _LOGRO_CATEGORIAS_MAP.clear();
}